import SimpleQuestion from "./SimpleQuestion";
import { NumericFormat } from "react-number-format";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useState, useEffect, useRef, useCallback } from "react";
import Button from "react-bootstrap/Button";
import {DeleteOutlineOutlined as DeleteOutlineOutlinedIcon , GetAppOutlined  } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadDocument,
  deleteDocument,
  updateProspectFormsForClient,
  updateProspectForms,
  getIsProspectSucceed,
  getIsProspectUpdating,
  getIsProspectDocument,
} from "../store/qf";
import { toast } from "react-toastify";
import { TextField } from "@material-ui/core";
import { getDocument } from "../helper/helper.js";
import Select from "react-dropdown-select";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";

const DocumentUpload = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  const [upImg, setUpImg] = useState();
  const [fileInfo, setfileInfo] = useState(false);
  const [fileType, setfileType] = useState([]);
  const [comment, setcomment] = useState("");
  const dispatch = useDispatch();
  const isProspectSucceed = useSelector(getIsProspectSucceed);
  const isProspectUpdating = useSelector(getIsProspectUpdating);
  const isProspectDocument = useSelector(getIsProspectDocument);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const documentUploadTranslations =
    translations[languagepreference].documentUpload;

  // let typeOfDocumentsArr = node.logic?.documentTypeList || [
  //   "Application",
  //   "Policy Document",
  //   "Quotation",
  //   "Risk Photo",
  //   "Inspection report",
  //   "Client email",
  //   "Insurer email",
  //   "Other email",
  //   "Building valuation",
  //   "Statement of Values",
  //   "Schedule",
  //   "Profits Calculation",
  //   "Other",
  // ];
  // Access the English documentUpload translations
  const englishDocumentTypeList =
    translations["en"].documentUpload.documentTypeList;

  // Define a list of document type keys based on the English translations
  const documentTypeKeys = Object.keys(englishDocumentTypeList);
  let typeOfDocumentsArr =
    node.logic?.documentTypeList ||
    documentTypeKeys.map((key) => englishDocumentTypeList[key]);

  // Generate the options array using the keys and translations
  const typeOfDocumentsOptions = typeOfDocumentsArr.map((englishValue) => {
    // Find the corresponding key in the English translations based on the English value
    const key = Object.keys(englishDocumentTypeList).find(
      (key) => englishDocumentTypeList[key] === englishValue
    );

    // Retrieve the translated label using the key, fallback to English value if translation is missing
    const translatedLabel = key
      ? documentUploadTranslations.documentTypeList[key] || englishValue
      : englishValue;

    return { value: englishValue, label: translatedLabel };
  });
  const [description, setdescription] = useState("");

  useEffect(() => {
    if (isProspectDocument && isProspectDocument?.nodeid == node.id) {
      if(isProspectDocument?.s3Delete){
        let filteredAnswer = node.answer.filter((x) =>  x.s3Upload?.ETag != isProspectDocument?.s3Upload?.ETag);
        handleAnswerChange(filteredAnswer)
      }
      else if (
        node.answer &&
        !node.answer?.find(
          (x) => x.s3Upload?.ETag == isProspectDocument?.s3Upload?.ETag
        )
      ) {
        handleAnswerChange([...node.answer, isProspectDocument]);
        //return;
      } else if (!node.answer) {
        handleAnswerChange([isProspectDocument]);
      }
      if (qfusermode === "client")
        dispatch(updateProspectFormsForClient({ updateFormsOrder: true }));
      if (qfusermode === "broker")
        dispatch(updateProspectForms({ updateFormsOrder: true }));
    }
    if(isProspectDocument && !isProspectDocument?.nodeid && isProspectDocument?.s3Delete){
      // backward compatiable with all document uploads that didnt have nodeid attached to em
      let filteredAnswer = node.answer.filter((x) =>  x.s3Upload?.ETag != isProspectDocument?.s3Upload?.ETag);
      handleAnswerChange(filteredAnswer)
    }
  }, [isProspectDocument]);

  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };

  const checkselectfile = (files) => {
    setfileInfo({
      fileName: files[0].name,
      type: files[0].type,
      size: files[0].size,
    });
    setfileType([]);
    setUpImg(files[0]);
  };
  const fileUploadhandler = (files) => {
    let data = {
      insurerCode: "test",
      file: upImg,
      ...fileInfo,
    };
    if (fileType.length == 0) {
      toast.error(documentUploadTranslations.fileTypeNotSelected);
      return;
    }
    data.fileType = fileType?.pop()?.value;
    data.comment = comment;
    data.uploadDate = new Date().toISOString().slice(0, 10);
    data.nodeid = node.id;
    const formData = new FormData();
    formData.append("file", upImg);
    //formData.append('data', data);
    dispatch(uploadDocument(formData, data));
    setfileInfo(false);
  };

  const convertSize = (bytes) => {
    if (bytes > 1000000 * 1000)
      return (bytes / (1000000 * 1000)).toFixed(2) + " GB";
    if (bytes > 1000000) return (bytes / 1000000).toFixed(2) + " MB";
    if (bytes > 999) return (bytes / 1000).toFixed(2) + " KB";
    if (bytes < 999) return bytes.toFixed(2) + " B";
  };

  const useClasses = makeStyles(theme => ({
    icon: {
        "&:hover": {
          color: 'red',
      }
    },
  }))
  const classes = useClasses()
  return (
    <div id="test2" style={{ width: "100%", marginBottom:"2vh", marginTop:"2vh" }}>
      <SimpleQuestion
        boxlist={false}
        node={node}
        leftString={text}
        rightComponent={
          <Dropzone onDrop={(files) => checkselectfile(files)} multiple={false}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p style={dropzoneStyle}>
                    {translations[languagepreference].dragAndDrop}
                  </p>
                </div>
              </section>
            )}
          </Dropzone>
        }
      ></SimpleQuestion>
      {fileInfo ? (
        <div>
          {/* <pre>
                {JSON.stringify(fileInfo, null, 2)}
            </pre> */}
          <table
            style={{
              borderCollapse: "collapse",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: "10px",
              marginTop: "21px",
            }}
          >
            {/* {Object.keys(fileInfo).map((x) => (
              <tr>
                <td style={{ paddingRight: "21px" }}>{x}: </td>
                <td>{fileInfo[x]}</td>
              </tr>
            ))} */}
            <tr>
              <td style={{ paddingRight: "21px" }}>
                {documentUploadTranslations.fileType}{" "}
              </td>
              <td>{fileInfo["fileName"]}</td>
            </tr>
            <tr>
              <td style={{ paddingRight: "21px" }}>Type </td>
              <td>{fileInfo["type"]}</td>
            </tr>
            <tr>
              <td style={{ paddingRight: "21px" }}>
                {documentUploadTranslations.size}{" "}
              </td>
              <td>{fileInfo["size"]}</td>
            </tr>
          </table>
          <div style={{}}>
            <Select
              placeholder={documentUploadTranslations.pleaseChooseFileType}
              color={theme.COLORS.primary_navyblue}
              dropdownHeight="20vh"
              onChange={(values) => {
                setfileType(values);
              }}
              values={fileType}
              options={typeOfDocumentsOptions}
              style={{
                width: "100%",
                height: "5vh",
                fontSize: "1.9vmin",
                border: "5px solid white",
                borderRadius: 15,
                fontFamily: "GibsonRegular",
                marginBottom: "5px",
                minWidth: "17vw",
              }}
            />
            <TextField
              style={{
                width: "45%",
                backgroundColor: "white",
                justifyContent: "center",
                margin: "auto",
                borderRadius: "8px",
                marginBottom: "6px",
                marginTop: "2px",
              }}
              // value={""}
              placeholder={documentUploadTranslations.comments}
              multiline
              minRows={2}
              maxRows={6}
              onBlur={(e) => {
                setcomment(e.target.value);
              }}
              // onChange={onChangeHandler}
            />
          </div>
          <Button
            style={{
              display: "block",

              height: "100%",
              maxHeight: "6vmin",
              backgroundColor: theme.COLORS.secondary_skyblue,
              borderRadius: 5,
              marginBottom: "15px",
              marginLeft: "10px",
              color: "white",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "GibsonRegular",
              fontSize: "min(0.8vw, 15px)",
              letterSpacing: 1,
              border: 0,
            }}
            onClick={() => fileUploadhandler()}
          >
            {documentUploadTranslations.upload}
          </Button>
        </div>
      ) : (
        ""
      )}

      {node.answer ? (
        <div>
          <table
            style={{
              width: "100%",
            }}
            id="documentUploadTable"
          >
            <tr>
              <th>{documentUploadTranslations.date}</th>
              <th>{documentUploadTranslations.fileType}</th>
              <th>{documentUploadTranslations.fileName}</th>
              <th>{documentUploadTranslations.size}</th>
              <th>{documentUploadTranslations.comment}</th>
              <th></th> {/* {documentUploadTranslations.download} */}
              <th></th> {/* Delete */}
            </tr>
            {node.answer.map((obj, index) => {
              return (
                <tr>
                  <td>{obj.uploadDate}</td>
                  <td>{obj.fileType}</td>
                  <td>{obj.fileName}</td>
                  <td>{convertSize(obj.size)}</td>
                  <td>{obj.comment}</td>
                  <td>
                    <GetAppOutlined
                      style={{ cursor:'pointer' }}
                      onClick={() => {
                        if (obj?.s3Upload?.Key) {
                          getDocument(obj.s3Upload.Key);
                        }
                        //getDocument(prospect.otherDetails.s3.key)
                        else {
                          toast.error(
                            documentUploadTranslations.somethingWentWrong
                          );
                        }
                      }}
                    />
                  </td>
                  <td>
                    <DeleteOutlineOutlinedIcon
                      className={classes.icon}
                      style={{ cursor:'pointer' }}
                      onClick={()=> {
                        dispatch(deleteDocument(obj))
                      }}
                    />
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      ) : null}
    </div>
  );
};


export const FileInfoTable = ({hideFileButton, fileInfo, setfileType, typeOfDocumentsOptions, fileType, setcomment, fileUploadhandler, prospectids, prospectType, setprospectType, hideComment }) => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const documentUploadTranslations = translations[languagepreference].documentUpload;
  return (
    <div style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around'
    }}>
      {/* <pre>
            {JSON.stringify(fileInfo, null, 2)}
        </pre> */}
      <table
        style={{
          borderCollapse: "collapse",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "5px",
          marginTop: "2px",
          'display' : fileInfo ? null : 'none'
        }}
      >
        {/* {Object.keys(fileInfo).map((x) => (
          <tr>
            <td style={{ paddingRight: "21px" }}>{x}: </td>
            <td>{fileInfo[x]}</td>
          </tr>
        ))} */}
        <tr>
          <td style={{ paddingRight: "21px" }}>
            {documentUploadTranslations.fileType}{" "}
          </td>
          <td>{fileInfo["fileName"]}</td>
        </tr>
        <tr>
          <td style={{ paddingRight: "21px" }}>Type </td>
          <td>{fileInfo["type"]}</td>
        </tr>
        <tr>
          <td style={{ paddingRight: "21px" }}>
            {documentUploadTranslations.size}{" "}
          </td>
          <td>{fileInfo["size"]}</td>
        </tr>
      </table>
      <div style={{}}>
        {typeOfDocumentsOptions && 
          <Select
            placeholder={documentUploadTranslations.pleaseChooseFileType}
            color={theme.COLORS.primary_navyblue}
            dropdownHeight="20vh"
            onChange={(values) => {
              setfileType(values);
            }}
            values={fileType}
            options={typeOfDocumentsOptions}
            style={{
              width: "100%",
              height: "5vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
              marginBottom: "5px",
              minWidth: "17vw",
            }}
          /> 
        }
        { prospectids && 
          <Select
            placeholder={"Please select the associated Product"}
            color={theme.COLORS.primary_navyblue}
            dropdownHeight="20vh"
            onChange={(values) => {
              setprospectType(values);
            }}
            values={prospectType}
            options={prospectids}
            menuPlacement="top"
            style={{
              width: "100%",
              height: "5vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
              marginBottom: "5px",
              minWidth: "17vw",
            }}
          />
        }
        <TextField
          style={{
            width: "95%",
            backgroundColor: "white",
            justifyContent: "center",
            margin: "auto",
            borderRadius: "8px",
            marginBottom: "6px",
            marginTop: "2px",
            display: hideComment ? "none" : null
          }}
          // value={""}
          placeholder={documentUploadTranslations.comments}
          multiline
          minRows={2}
          maxRows={6}
          onBlur={(e) => {
            setcomment(e.target.value);
          }}
          // onChange={onChangeHandler}
        />
      </div>
      <Button
        style={{
          display: hideFileButton ? "none" : "block",
          height: "100%",
          maxHeight: "6vmin",
          backgroundColor: theme.COLORS.secondary_skyblue,
          borderRadius: 5,
          marginBottom: "15px",
          marginLeft: "10px",
          color: "white",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "GibsonRegular",
          fontSize: "min(0.8vw, 15px)",
          letterSpacing: 1,
          border: 0,
        }}
        onClick={() => fileUploadhandler()}
      >
        {documentUploadTranslations.upload}
      </Button>
    </div>
  )
}

export default DocumentUpload;
